// extracted by mini-css-extract-plugin
export var actionButton = "_7w-0";
export var attachmentLine = "_7w-1";
export var fileInput = "_7w-2";
export var fileUploadWrapper = "_7w-4";
export var footer = "_7w-3";
export var modalContent = "_7w-5";
export var paperclip = "_7w-6";
export var quillEditor = "_7w-7";